var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {


        const link = $('.block-article-content__wrapper p a');
        const linkColor = link.closest('p').css('color');
        link.css('color',linkColor);
        link.addClass('global-link');


        const linkLi = $('.block-article-content__wrapper li a');
        const linkColorLi = linkLi.closest('li').css('color');
        linkLi.css('color',linkColorLi);
        linkLi.addClass('global-link');

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=article-content', initializeBlock);
    }
});
